<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "bkm-wrapper"
};
</script>

<style>
</style>